<template>
  <div class="page">
    <div class="loginBox" @keyup.enter="loginFunc">
      <h1 class="logo">crazy poker后台管理</h1>
      <div class="inputWrap">
        <el-input placeholder="请输入" v-model="username">
          <template slot="prepend">账号</template>
        </el-input>
      </div>
      <div class="inputWrap">
        <el-input placeholder="请输入" v-model="password" type="password">
          <template slot="prepend">密码</template>
        </el-input>
      </div>
      <el-button
        class="loginBtn"
        type="primary"
        @click="loginFunc"
        v-loading.fullscreen.lock="fullscreenLoading"
        >登录</el-button
      >
    </div>

    <div v-show="show" class="common-popup-bg">
      <div class="common-popup">
        <h3>提示</h3>
        <div class="common-popup-table">
          谷歌验证码：<el-input class="code" v-model="code" placeholder="请输入谷歌验证码" />
        </div>
        <footer>
          <el-button @click="show = false" size="small">取消</el-button>
          <el-button size="small" type="primary" @click="codeLogin">确定</el-button>
        </footer>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex';

export default {
  data() {
    return {
      show: false,
      fullscreenLoading: false,
      username: '',
      password: '',
      code: '',
    };
  },
  beforeRouteEnter(to, from, next) {
    if (localStorage.getItem('token')) {
      next('/');
    } else {
      next();
    }
  },
  methods: {
    ...mapActions('login', ['login', 'sendSmsForRoot']),
    loginFunc() {
      this.fullscreenLoading = true;
      this.login({
        username: this.username,
        password: window.btoa(this.password),
        systemCode: 'OSM',
      })
        .then((res) => {
          if (res.code === 10016) {
            this.show = true;
            this.fullscreenLoading = false;
          }
        })
        .catch(() => {
          this.fullscreenLoading = false;
        });
    },
    codeLogin() {
      if (!this.code) {
        this.$message.error('请输入验证码');
        return;
      }
      this.fullscreenLoading = true;
      this.login({
        username: this.username,
        password: window.btoa(this.password),
        smsCode: this.code,
        systemCode: 'OSM',
      })
        .then(() => {
          this.show = false;
        })
        .catch(() => {
          this.fullscreenLoading = false;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.page {
  position: relative;
  width: 100%;
  height: 100vh;
}

.loginBox {
  position: absolute;
  top: 40%;
  left: 50%;
  width: 320px;
  line-height: 60px;
  transform: translate(-50%, -50%);
}

.common-popup-table {
  width: 350px;
  padding-bottom: 20px;
}

.logo {
  color: $theme-color;
  text-align: center;
}
.inputWrap {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}
.code {
  width: 180px;
  margin-right: 10px;
}
.loginBtn {
  width: 100%;
}
</style>
